module.exports = BD.Model.extend({
    organization: BD.belongsTo('Billy.Organization'),
    createdTime: BD.attr('datetime', { readonly: true }),
    invitedByUser: BD.belongsTo('Billy.User', { readonly: true }),
    email: BD.attr('string'),
    type: BD.attr('string')
})
